import { FC, memo } from 'react';

const FourZeroFourComponent: FC = memo(() => <div />);

export default FourZeroFourComponent;
